exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".infoContainer_1DWBn {\n    padding: 0 80px;\n}\n\n.infoContainer_1DWBn .textPadding_1DiCR {\n    padding: 15px 0 40px 0;\n}\n\n.rowLeft_3R1Mr {\n    float: left;\n    width: 30%;\n}\n\n.gapSection1_1sXEB {\n    height: 480px;\n}\n", ""]);

// exports
exports.locals = {
	"infoContainer": "infoContainer_1DWBn",
	"textPadding": "textPadding_1DiCR",
	"rowLeft": "rowLeft_3R1Mr",
	"gapSection1": "gapSection1_1sXEB"
};